import axiosClient from "./axios";

/**
 * Kullanıcının enerji taşlarını getirir
 * @returns {Promise} Enerji taşları verisi
 */
export const getEnergyStones = async () => {
  try {
    const response = await axiosClient.get("/module/energy-stones");
    return response.data;
  } catch (error) {
    console.error("Enerji taşları alınırken hata:", error);
    throw error;
  }
};

